module.exports = __webpack_public_path__ + "static/media/468x60_0057_ru.3dfa1e2b.png";